"use client";

import CustomImage from "@/components/image";
import Button from '@/components/button';
import styles from './_access-simplified.module.scss';

export default function HcpAccessSimplified() {
  return (
    <div className={styles.container}>
      <div className="container container--px-16">
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <p className={styles.intro}>
              ACCESS SIMPLIFIED
            </p>
            <h2 className={styles.heading}>
              Dedicated team of Care Coordinators
            </h2>
            
            <p className={styles.dosing_access_simplified_p1}>The Neurocrine Access Support program provides patients a dedicated Care Coordinator as a central point of contact from initiation through their entire treatment journey.</p>

            <Button
              variant={["outline", "outline--eggplant", "outline-transparent", "hcp-big"]}
              customClass={styles.btn}
              data-gtm-event-category="Internal Link"
              data-gtm-event-action="Click"
              data-gtm-event-label="Discover Access Support"
              href="/support-resources"
            >Discover Access Support</Button>
          </div>

          <div className={styles.content}>
            <CustomImage
              className="mx-auto hidden tablet:block"
              src="/images/components/Access-Support.png"
              alt=""
              width={617}
              height={437}
            />
            <CustomImage
              className="mx-auto block tablet:hidden"
              src="/images/components/Access-Support-m.png"
              alt=""
              width={343}
              height={353}
            />
            {/* <p className={`${styles.content_image_text}`}>Actor portrayals.</p> */}
          </div>
        </div>
      </div>
    </div>
  );
}